(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-section-type="blog"][data-section-id]');
    var grid = root && root.querySelector('.grid--uniform');
    var pagination = root && root.querySelector('.pagination');
    if (!grid || !pagination || root.dataset.libasInfinite === 'ready' || !('IntersectionObserver' in window)) return;
    root.dataset.libasInfinite = 'ready';
    var loading = false;
    var stopped = false;
    var controller;
    var visited = new Set();
    var status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    pagination.before(status);
    function articleKey(card) {
      var link = card.querySelector('a.article__title, a.article__grid-image');
      return link && new URL(link.getAttribute('href'), location.href).pathname;
    }
    var seen = new Set(Array.from(grid.children, articleKey).filter(Boolean));
    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) loadNext();
    }, {rootMargin: '0px 0px 500px 0px'});
    async function loadNext() {
      if (loading || stopped || !root.isConnected) return;
      var link = pagination.querySelector('.next a[href]');
      if (!link) { observer.disconnect(); return; }
      var next = new URL(link.getAttribute('href'), location.href);
      if (next.origin !== location.origin || next.pathname !== location.pathname || visited.has(next.href)) {
        observer.disconnect();
        return;
      }
      var pageKey = next.href;
      next.searchParams.set('section_id', root.dataset.sectionId);
      loading = true;
      grid.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading more stories';
      controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(next.href, {credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) throw new Error('Unable to load blog page');
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedRoot = Array.from(doc.querySelectorAll('[data-section-type="blog"]')).find(function (element) {
          return element.dataset.sectionId === root.dataset.sectionId;
        });
        var fetchedGrid = fetchedRoot && fetchedRoot.querySelector('.grid--uniform');
        if (!fetchedGrid || !root.isConnected) throw new Error('Blog section unavailable');
        var added = 0;
        Array.from(fetchedGrid.children).forEach(function (card) {
          var key = articleKey(card);
          if (!key || seen.has(key)) return;
          seen.add(key);
          // Newly appended cards must remain visible without re-running theme animations.
          card.removeAttribute('data-aos');
          grid.appendChild(document.importNode(card, true));
          added += 1;
        });
        if (!added) throw new Error('No new stories');
        visited.add(pageKey);
        observer.unobserve(pagination);
        var replacement = fetchedRoot.querySelector('.pagination');
        if (replacement) {
          var newPagination = document.importNode(replacement, true);
          pagination.replaceWith(newPagination);
          pagination = newPagination;
          if (pagination.querySelector('.next a[href]')) observer.observe(pagination);
        } else {
          pagination.remove();
          observer.disconnect();
        }
        status.textContent = added + ' more stories loaded';
        root.dataset.libasLoadedPages = String(visited.size + 1);
      } catch (error) {
        // Leave the original page links usable and avoid background retry loops.
        stopped = true;
        observer.disconnect();
        status.textContent = 'Use the page links below to browse more stories.';
      } finally {
        window.clearTimeout(timeout);
        loading = false;
        grid.removeAttribute('aria-busy');
      }
    }
    observer.observe(pagination);
    window.addEventListener('pagehide', function () {
      observer.disconnect();
      if (controller) controller.abort();
    }, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

